export interface FoodCostDocumentOriginFood {
  id: string;
  last_unit_cost_event_id?: string | null;
  last_unit_cost_source_kind?: 'purchase' | 'manual_adjustment' | null;
}

export interface FoodCostDocumentOriginEvent {
  id?: string | null;
  server_id?: string | null;
  client_uuid?: string | null;
  payload?: { document_id?: unknown } | null;
}

function text(value: unknown): string | null {
  return typeof value === 'string' && value.trim() ? value.trim() : null;
}

/** Ricollega l'evento che ha originato il costo, non l'ultimo carico dello stesso alimento. */
export function foodCostDocumentOriginByFood(
  foods: readonly FoodCostDocumentOriginFood[],
  purchaseEvents: readonly FoodCostDocumentOriginEvent[],
): Map<string, string> {
  const documentByEventId = new Map<string, string>();
  for (const event of purchaseEvents) {
    const documentId = text(event.payload?.document_id);
    if (!documentId) continue;
    for (const id of [event.id, event.server_id, event.client_uuid]) {
      const key = text(id);
      if (key) documentByEventId.set(key, documentId);
    }
  }
  const result = new Map<string, string>();
  for (const food of foods) {
    if (food.last_unit_cost_source_kind !== 'purchase') continue;
    const eventId = text(food.last_unit_cost_event_id);
    const documentId = eventId ? documentByEventId.get(eventId) : null;
    if (documentId) result.set(food.id, documentId);
  }
  return result;
}
